var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0L57.5 0 57.5 57 0.5 57z",
    transform: "translate(-95 -381) translate(60 349) translate(35.5 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CABE0",
    fillRule: "nonzero",
    d: "M28.5 35c5.249 0 9.5-4.251 9.5-9.5S33.749 16 28.5 16 19 20.251 19 25.5s4.251 9.5 9.5 9.5zm0 4.75c-6.341 0-19 3.182-19 9.5V54h38v-4.75c0-6.318-12.659-9.5-19-9.5z",
    transform: "translate(-95 -381) translate(60 349) translate(35.5 32)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson24Px);
export default __webpack_public_path__ + "static/media/person-24-px.a39a5ae74a564f26c455f1f58a684904.svg";
export { ForwardRef as ReactComponent };